import { BitrixVue } from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { ItemEditBtns } from 'vpl.tas';


export const MpSupply = {
    components: {
        ItemEditBtns
    },
    props: {
        structKey: [String, Number]
    },
    methods: {
        showMore(event) {

            let btn = $(event.target),
                list = $(this.$el).find('.js-catalog-list');

            if (!btn.hasClass('is-show')) {
                btn.addClass('is-show');
                btn.text('Свернуть');
                list.addClass('is-show');
            } else {
                btn.removeClass('is-show');
                btn.text('Показать ещё');
                list.removeClass('is-show');
                $('html').animate({
                    scrollTop: list.offset().top - 150
                }, 500);
            }

        }
    },
    updated() {

    },
    mounted() {

    },
    computed: {
        ...mapState(vplSiteStore, ['struct', 'SITE_TEMPLATE_PATH'])
    },
    template: `
<section v-if="this.struct[this.structKey].componentData.ITEMS" class="section">
    <div class="container">
        <div class="section__heading">
            <div class="section__title-wp">
                <h2 class="section__title">
					Комплексное оснащение
                </h2>
            </div>
            <div class="section__nav">
                <a :href="this.struct[this.structKey].componentData.LIST_PAGE_URL" class="section__nav-link">
                    Все
                    <svg class="icon icon-arrow-next"><use xlink:href="#icon-arrow-next"></use></svg>
                </a>
            </div>
        </div>
        <div class="catalog__mp">
            <div class="catalog__mp-list js-catalog-list">

                <a v-for="item in this.struct[this.structKey].componentData.ITEMS" :key="item.ID" :href="item.LINK" class="catalog__item js-catalog-item">
                    <div class="catalog__item-name">{{item.NAME}}</div>
                    <div class="catalog__item-img" :class="{'no-photo': item.PICTURE === false}">
                        <img v-if="item.PICTURE !== false" class="lazy" loading="lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="item.PICTURE" :alt="item.NAME" :title="item.NAME">
                        <img v-else :src="this.SITE_TEMPLATE_PATH + '/img/svg/no-photo.svg'" :alt="item.NAME" :title="item.NAME" loading="lazy">
                    </div>
                </a>
                <!--
                <div class="catalog__item-calc lazy-bg">
                    <div class="catalog__item-calc-name">
                        Калькулятор  комплексного оснащения
                    </div>
                    <a href="/osnashchenie/#calc" class="catalog__item-calc-subtitle">
                        <div class="catalog__item-calc-icon">
                            <svg class="ico ico-calc ico-solo" width="20" height="20" aria-hidden="true"><use xlink:href="#ico-calc"></use></svg>
                        </div>
                        Рассчитать
                    </a>
                </div>
                -->
            </div>
            <a
                href="#" class="btn btn--border js-catalog-show"
                @click.prevent="showMore($event)"
                :class="{'is-active': this.struct[this.structKey].componentData.ITEMS.length > 8}"
                >
                Показать ещё
            </a>
            <!--
            <div class="catalog__item-calc lazy-bg">
                <div class="catalog__item-calc-name">
                    Калькулятор  комплексного оснащения
                </div>
                <a href="/osnashchenie/#calc" class="catalog__item-calc-subtitle">
                    <div class="catalog__item-calc-icon">
                        <svg class="ico ico-calc ico-solo" width="20" height="20" aria-hidden="true"><use xlink:href="#ico-calc"></use></svg>
                    </div>
                    Рассчитать
                </a>
            </div>
            -->

            <a href="//arona.tas.pro/" target="_blank" rel="nofollow" class="catalog__mp-promo">

                <picture class="catalog__mp-promo-logo">
                    <source data-srcset="/local/templates/vpl_vue/img/svg/arona-promo-logo-2.svg" media="(max-width: 768px)">
                    <img class="lazy" loading="lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="this.SITE_TEMPLATE_PATH + '/img/svg/arona-promo-logo-1.svg'" alt="" title="">
                </picture>
                <div class="catalog__mp-promo-img">
                    <picture>
                        <picture>
                            <source type="image/avif" :data-srcset="this.SITE_TEMPLATE_PATH + '/img/content/arona-bg-center.avif'">
                            <source type="image/webp" :data-srcset="this.SITE_TEMPLATE_PATH + '/img/content/arona-bg-center.webp'">
                            <img class="lazy" loading="lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="this.SITE_TEMPLATE_PATH + '/img/content/arona-bg-center.png'" alt="" title="">
                        </picture>
                    </picture>
                </div>
                <div class="catalog__mp-promo-subtitle">
                    Арона — уникальный бренд витрин, специализирующийся на дизайнерских решения для ресторанов, отелей, магазинов
                </div>
            </a>
        </div>
    </div>
</section>
    `
}